import { render, staticRenderFns } from "./teacherDetail.vue?vue&type=template&id=fdcf4ffa&scoped=true"
import script from "./teacherDetail.vue?vue&type=script&lang=js"
export * from "./teacherDetail.vue?vue&type=script&lang=js"
import style0 from "./teacherDetail.vue?vue&type=style&index=0&id=fdcf4ffa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdcf4ffa",
  null
  
)

export default component.exports